import { __awaiter, __decorate, __generator, __metadata, __param } from "tslib";
import { dataFieldNamingHandler, exceptionHandler } from '../../base/decorators';
import { INetworkRequestService } from '../../base/request/network-request.interface';
import { IDocMetaDomainService } from '../../doc-meta/service/doc-meta-domain-service.interface';
import ShareRepository from '../repository/share-repository';
var ShareEntity = /** @class */ (function () {
    function ShareEntity(docMetaDomainService, networkRequest) {
        this.docMetaDomainService = docMetaDomainService;
        this.networkRequest = networkRequest;
        this.shareRepository = new ShareRepository(docMetaDomainService, networkRequest);
    }
    ShareEntity.prototype.sendDocToMember = function (memberList, corpId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.shareRepository.sendDocToMember(memberList, corpId)];
            });
        });
    };
    ShareEntity.prototype.fetchRecentUserInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.shareRepository.fetchRecentUserInfo()];
            });
        });
    };
    ShareEntity.prototype.exportToPC = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.shareRepository.exportToPC()];
            });
        });
    };
    ShareEntity.prototype.fetchBrowserList = function (start, count) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.shareRepository.fetchBrowserList(start, count)];
            });
        });
    };
    __decorate([
        dataFieldNamingHandler(),
        exceptionHandler(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array, String]),
        __metadata("design:returntype", Promise)
    ], ShareEntity.prototype, "sendDocToMember", null);
    __decorate([
        dataFieldNamingHandler(),
        exceptionHandler(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], ShareEntity.prototype, "fetchRecentUserInfo", null);
    __decorate([
        dataFieldNamingHandler(),
        exceptionHandler(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], ShareEntity.prototype, "exportToPC", null);
    __decorate([
        dataFieldNamingHandler(),
        exceptionHandler(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number, Number]),
        __metadata("design:returntype", Promise)
    ], ShareEntity.prototype, "fetchBrowserList", null);
    ShareEntity = __decorate([
        __param(0, IDocMetaDomainService),
        __param(1, INetworkRequestService),
        __metadata("design:paramtypes", [Object, Object])
    ], ShareEntity);
    return ShareEntity;
}());
export default ShareEntity;
